import * as PIXI from 'pixi.js';
import { state } from '__common/store';
import { isBlankMap } from '__common/constants/map';

function roofEdges(coordsInPx: pixelPoint[]): PIXI.Graphics {
  const { roofsSelector: { mapType } } = state();
  const COLOR_BLACK = 0x00000;
  const COLOR_WHITE = 0xFFFFFF;
  const lineColor = isBlankMap(mapType) ? COLOR_BLACK : COLOR_WHITE;
  const edges: PIXI.Graphics = new PIXI.Graphics();
  const dots: PIXI.Graphics[] = [];

  // Filter out undefined or invalid coordinates
  const validCoords = coordsInPx.filter(coord => coord && coord.x !== undefined && coord.y !== undefined && !isNaN(coord.x) && !isNaN(coord.y));
  
  if (validCoords.length === 0) {
    console.warn('No valid coordinates provided to roofEdges function');
    return edges;
  }

  const newCoords = validCoords.reduce<number[]>((acc, coord) => {
    acc.push(coord.x);
    acc.push(coord.y);
    dots.push(drawEndLineDot(coord.x, coord.y));
    return acc;
  }, []);

  if (newCoords.length < 6) { // Need at least 3 points (6 numbers) for a polygon
    console.warn('Insufficient coordinates for polygon - need at least 3 points');
    return edges;
  }

  try {
    const poly = new PIXI.Polygon(newCoords);
    edges.interactive = true;
    // PIXI v7: Set eventMode for proper interaction
    edges.eventMode = 'static';
    edges.hitArea = poly;
    edges.lineStyle(0.2, lineColor);
    edges.beginFill(COLOR_WHITE, 0.25);
    // Close the polygon by adding the first point at the end
    const closedCoords = [...newCoords, newCoords[0], newCoords[1]];
    edges.drawPolygon(closedCoords);
    edges.id = 'roofEdges';
    dots.map(dot => edges.addChild(dot));
    edges.zIndex = 99999;
  } catch (error) {
    console.error('Error creating roof edges polygon:', error);
  }
  
  return edges;
}

function drawEndLineDot(x, y) {
  const dot: PIXI.Graphics = new PIXI.Graphics();
  dot.beginFill(0xFFFFFF, 1);
  dot.drawCircle(x, y, 0.1);
  dot.id = 'endLineRoofEdgeDot';
  dot.endFill();
  return dot;
}

export default roofEdges;
